








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Logo from '@components/Logo.vue';
import copy from '@shared/constants/copy';
import ProductTitle from '@components/ProductTitle.vue';
import AssessmentHomeCard from '@components/assessment/AssessmentHomeCard.vue';
import WelcomeCard from '@components/WelcomeCard.vue';
import AssessmentStore from '@store/assessment';
import SignUpView from '@components/auth/SignUpView.vue';
import { RouteName } from '@shared/routing/PageRoutes';

@Component({
    components: {
        SignUpView,
        WelcomeCard,
        AssessmentHomeCard,
        ProductTitle,
        Logo,
    },
})
export default class IndexVue extends Vue {
    env = JSON.stringify(this.$config);

    get assessment(): AssessmentStore {
        return getModule(AssessmentStore, this.$store);
    }

    head() {
        return {
            title: `${this.$config.titlePrefix ?? ''} ${copy.brandName}`.trim(),
        };
    }

    created() {
        if (this.$auth.loggedIn) {
            this.$router.replace({ name: RouteName.dashboard });
        }
    }

    async fetch() {
        if (this.$auth.loggedIn) {
            await this.assessment.loadCurrentAssessment();
        }
    }
}
